import React, { PureComponent, useEffect, useState } from "react";
import { AxiosCustomPost } from "../components/axios/AxiosCustom";
import Config from "../components/axios/Config";
import Cookie from "js-cookie";
import AppRoutePath from "../router/AppRoutePath";
import SwalToast from "../components/helpers/SwalToast";
import IsEmpty from "../components/helpers/IsEmpty";
import { Modal, Button, Input } from "antd";
import ErrorDiv from "../components/helpers/ErrorDiv";
import PasswordChecklist from "react-password-checklist";

function ResetPassword(props) {
  const [password, setPassword] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");
  const [modalResetSent, setModalResetSent] = useState(false);
  const [errorPaswordNotMatch, setErrorPaswordNotMatch] = useState();
  const queryParams = new URLSearchParams(window.location.search);
  const token = queryParams.get("_token");
  const email = queryParams.get("_email");
  const type = queryParams.get("_type");

  useEffect(() => {
    if (
      !IsEmpty(Cookie.get("access_token")) &&
      !IsEmpty(Cookie.get("refresh_token"))
    ) {
      props.history.push(AppRoutePath.DASHBOARD);
    }
  }, []);

  const changeValue = (event) => {
    if (event.target.name === "password") {
      setPassword(event.target.value);
    } else if (event.target.name === "repeat-password") {
      setRepeatPassword(event.target.value);
    }
  };

  const validateReset = () => {
    let validate = true;
    setErrorPaswordNotMatch();

    if (password !== repeatPassword) {
      validate = false;
      SwalToast.fire({
        icon: "error",
        title: "Password tidak sama",
      });
    }
    return validate;
  };

  const submit = (event) => {
    event.preventDefault();
    // if (!validateReset()) return;
    AxiosCustomPost(
      `${process.env.REACT_APP_BASE_API_URL}auth/new-password`,
      {
        email: email,
        token: token,
        new_password: password,
      },
      Config(),
      (response) => {
        setModalResetSent(true);
      },
      (error) => {
        if (error.response) {
          console.log(error.response.data.error);
          SwalToast.fire({
            icon: "error",
            title: error.response.data.error.message,
          });
        } else {
          console.log(error);
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  return (
    <div
      className=""
      style={{
        // width: 550,
        height: "100vh",
        backgroundImage: `url(${process.env.REACT_APP_PUBLIC_URL}images/background.jpg)`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      }}
    >
      <div className="ohana-container-login d-flex justify-content-center align-items-center">
        <form
          onSubmit={submit}
          className="bg-white shadow-graph mx-auto p-3"
          style={{ width: 500, borderRadius: 12, height: 700 }}
        >
          <div className="d-flex flex-column align-items-center">
            <div className="d-flex align-items-center pt-5">
              <img
                src={`${process.env.REACT_APP_PUBLIC_URL}images/degadai-logo.svg`}
                style={{ width: 304, height: 159, left: 76.5, top: 36 }}
              />
            </div>

            <div className="px-1">
              <div className="pt-3 d-flex align-self-start">
                <h4 className="color-303030 font-weight-bold">
                  {type === "reset" ? "Reset Password" : "Verifikasi Akun"}
                </h4>
              </div>

              <div className="form-group mt-3" style={{ height: 36 }}>
                <label htmlFor="email" className="color-A6A6A6">
                  Password Baru
                </label>
                <input
                  type="password"
                  className="form-control border-radius-8-px"
                  id="password"
                  name="password"
                  required
                  value={password}
                  onChange={changeValue}
                />
              </div>
              <div
                className="form-group mt-5"
                style={{ width: 367, height: 36 }}
              >
                <label
                  htmlFor="virtual-sdb-desktop-password"
                  className="color-A6A6A6"
                >
                  Ulangi Password
                </label>
                <input
                  type="password"
                  className="form-control border-radius-8-px"
                  id="repeat-password"
                  name="repeat-password"
                  required
                  value={repeatPassword}
                  onChange={changeValue}
                />
                <div className="mt-3">
                  <ErrorDiv error={errorPaswordNotMatch} />
                </div>
              </div>
              <div
                className="form-group mt-5"
                style={{ width: 367, height: 36 }}
              >
                <PasswordChecklist
                  rules={[
                    "minLength",
                    "specialChar",
                    "number",
                    "capital",
                    "match",
                  ]}
                  minLength={8}
                  value={password}
                  valueAgain={repeatPassword}
                  onChange={(isValid) => {}}
                />
                <button
                  style={{ height: 42 }}
                  type="submit"
                  className="form-control btn text-white bgc-2C465C border-radius-8-px mt-3"
                >
                  Ganti Password
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
      <Modal
        centered
        title={`Berhasil`}
        visible={modalResetSent}
        // onOk={handleSubmit}
        // onCancel={() => props.navigation.navigation(AppRoutePath.LOGIN)}
        footer={[
          <Button
            type="submit"
            onClick={() => props.history.push(AppRoutePath.LOGIN)}
            style={{
              border: "0.75px solid #DCDCDC",
              borderRadius: 6,
              width: 120,
              height: 48,
              color: "#fff",
              background: "#2C465C",
            }}
          >
            Login Ulang
          </Button>,
        ]}
      >
        <div className="my-3">
          <p>Password berhasil di ubah, silahkan login Kembali</p>
        </div>
      </Modal>
    </div>
  );
}

export default ResetPassword;
